module.exports = __webpack_public_path__ + "img/iconePedidos.5a2ba3a0.png";